import React from 'react';
import GallectionCover from '../GallectionCover';
import { PapiGallection } from '@wix/da-papi-types';
import {
  ListItemCheckbox,
  type ListItemCheckboxProps,
} from '@wix/da-ds/pkg/List/ListItem';

export interface Props
  extends Omit<
    ListItemCheckboxProps,
    'label' | 'name' | 'prefix' | 'fillContainerWidth' | 'onChange'
  > {
  gallection: PapiGallection;
  onChange?: ({
    folderId,
    isSelected,
  }: {
    folderId: number;
    isSelected: boolean;
  }) => void;
}

const GallectionListItemCheckbox: React.FC<Props> = ({
  gallection,
  onChange,
  ...rest
}) => {
  return (
    <ListItemCheckbox
      label={gallection.name}
      name={gallection.name}
      prefix={<GallectionCover gallection={gallection} />}
      fillContainerWidth
      controlAlignment="center"
      onChange={isSelectedNew => {
        onChange &&
          onChange({
            folderId: gallection.folderId,
            isSelected: isSelectedNew,
          });
      }}
      {...rest}
    />
  );
};

GallectionListItemCheckbox.displayName = 'GallectionListItemCheckbox';

export default GallectionListItemCheckbox;
